/**
 * Where to send someone AFTER they log in, when they were already on their way somewhere.
 *
 * The case that matters: a visitor clicks Subscribe while logged out. We have to send them
 * to log in, but without remembering why, they land on the homepage afterwards and have to
 * rediscover the pricing page by themselves. That's the single visitor who had already
 * decided to pay us, and we were dropping them.
 *
 * sessionStorage, not localStorage: the intent belongs to this visit. A stale "take me to
 * pricing" surfacing days later would be baffling.
 */
export const POST_LOGIN_INTENT_KEY = "cc_post_login_intent";

/** Read and clear the pending destination. Returns null when there isn't one. */
export function takePostLoginIntent(): string | null {
  try {
    const to = sessionStorage.getItem(POST_LOGIN_INTENT_KEY);
    if (to) sessionStorage.removeItem(POST_LOGIN_INTENT_KEY);
    return to || null;
  } catch (e) {
    return null;
  }
}
